import { CompRule, PayeeSummary } from '../types/commission';
import { formatPct, formatUsd, formatWholeUsd, sumCents } from './format';

/** Stored (unadjusted) reference total — Loan Amount × BPS lines, including the TL / Director row. */
export function payeeStoredTotal(payee: PayeeSummary): number {
  return sumCents([payee.base, payee.bonus, payee.overrides, payee.manual]);
}

export function formatRuleValue(rule: CompRule): string {
  if (rule.value === null) return rule.sourceNote ?? 'TBD';
  if (rule.unit === '$') return formatUsd(rule.value);
  if (rule.unit === '%') return formatPct(rule.value);
  const signed = rule.ruleType === 'Monthly Bonus' && rule.value > 0;
  return `${signed ? '+' : ''}${rule.value}`;
}

export function formatRuleBound(rule: CompRule, which: 'min' | 'max'): string {
  if (rule.basis === 'none') return '—';
  const value = rule[which];
  if (value === null) return which === 'max' ? 'and up' : '—';
  const text = rule.basis === 'volume' ? formatWholeUsd(value) : String(value);
  return which === 'max' && rule.maxExclusive ? `< ${text}` : text;
}

export function isPlanRuleKey(ruleKey: string): boolean {
  return /^V\d+-/.test(ruleKey);
}
